export default __webpack_public_path__ + "static/media/login_bg.bed6b651.png";